<template>
  <div class="row d-flex align-items-stretch">
    <div class="col-12 col-sm-3">
      <div class="card h-100" :class="getNpsColor(nps.nps)">
        <div
          class="card-body d-flex justify-content-center text-center text-light"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h5 class="card-title">NPS</h5>
              <h6 class="card-subtitle">Net Promoter Score</h6>
              <h2 class="mb-0">{{ nps.nps }}%</h2>
              <button
                class="btn btn-light btn-sm mt-2"
                title="Detalhar"
                data-bs-toggle="collapse"
                href="#collapse-nps-details"
              >
                <i class="ph ph-list-magnifying-glass"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-9">
      <div class="card h-100">
        <table class="table table-sm table-hover table-striped">
          <thead>
            <tr>
              <th>Tipo</th>
              <th class="text-center">Quantidade</th>
              <th class="text-center">Porcentagem</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Promotores</td>
              <td class="text-center">{{ nps.promoters }}</td>
              <td class="text-center">{{ nps.promotersPercentage }}%</td>
            </tr>
            <tr>
              <td>Detratores</td>
              <td class="text-center">{{ nps.detractors }}</td>
              <td class="text-center">{{ nps.detractorsPercentage }}%</td>
            </tr>
            <tr>
              <td>Neutros</td>
              <td class="text-center">{{ nps.passives }}</td>
              <td class="text-center">{{ nps.passivesPercentage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12 collapse" id="collapse-nps-details">
      <div class="card table-responsive mt-2">
        <table
          class="table table-hover table-striped table-sm fs-sm"
          :id="dataTable.id"
        >
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Solicitante</th>
              <th>Técnico</th>
              <th class="text-center">Ticket</th>
              <th class="text-center">Enviado</th>
              <th class="text-center">Respondido</th>
              <th>Pergunta</th>
              <th class="text-center">Nota</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in nps.raw" :key="item.id">
              <td>{{ item.organization }}</td>
              <td>{{ item.requester }}</td>
              <td>{{ item.technicianName }}</td>
              <td class="text-center">{{ item.ticketId }}</td>
              <td class="text-center">
                <span class="d-none">{{ item.sendAt }}</span>
                {{ dateTimeSqlToDateTimeBR(item.sendAt) }}
              </td>
              <td class="text-center">
                <span class="d-none">{{ item.answerAt }}</span>
                {{ dateTimeSqlToDateTimeBR(item.answerAt) }}
              </td>
              <td>{{ item.field1 }}</td>
              <td class="text-center">{{ item.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import '@/utils/basicDataTableExtend'

export default {
  name: 'NpsCard',

  props: {
    nps: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTableListNps',
        order: [[4, 'DESC']],
      },
      dateTimeSqlToDateTimeBR,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable(this.dataTable)
    },

    getNpsColor(nps) {
      if (nps >= 70) {
        return 'bg-success'
      }
      if (nps >= 50) {
        return 'bg-warning'
      }
      return 'bg-danger'
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
